/**
 * GET-COLOR
 * Get hex value for list of colors
 */

const getColor = (color: string) => {
  switch (color) {
    case "black":
      return "#111C2B"
    case "grey":
      return "#8C8C8C"
    case "red":
      return "#eb5a46"
    case "orange":
      return "#ff9500"
    case "yellow":
      return "#F2D600"
    case "lime":
      return "#D8C300"
    case "green":
      return "#20CA7E"
    case "blue":
      return "#7d8ee0"
    case "lightblue":
      return "#afbbf4"
    case "darkblue":
      return "#50c9cd"
    default:
      return ""
  }
}

export default getColor
